import React from "react";

export default function AppPromoSection() {
  return (
      <section
          className="
        relative
        overflow-hidden
        bg-[linear-gradient(21deg,_rgba(58,137,215,1)_0%,_rgba(45,89,132,1)_34%)]
        bg-cover
        bg-center
        bg-no-repeat
      "
      >
        <div className="mx-auto w-full max-w-[1200px] px-4 py-16 sm:py-20">
          <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-12">
            {/* LEFT: phones */}
            <div className="relative mx-auto w-full max-w-[720px] lg:max-w-none">
              <div className="relative flex items-end justify-center gap-6 sm:gap-8 lg:justify-start">
                <div className="relative z-10 w-[230px] sm:w-[300px] lg:w-[555px]">
                  <img
                      src="/img/app-promo-section.png"
                      alt="Yoga7 app preview"
                      className="w-full select-none"
                      draggable={false}
                  />
                </div>
              </div>
            </div>


            {/* RIGHT: text */}
            <div className="text-center text-white">
              <div className="font-helvetica text-[16px] font-medium leading-[40px] tracking-[0.04em] sm:text-[18px]">
                Available for Apple and Android
              </div>

              <h3 className="mt-8 font-helvetica text-[42px] font-medium leading-[46px] sm:text-[56px] sm:leading-[62px]">
                Sign up book
                <br/>
                classes and more
              </h3>

              <p className="mx-auto mt-6 max-w-[560px] font-helvetica text-[18px] font-medium leading-[30px] tracking-[0.04em] sm:text-[20px] sm:leading-[34px] lg:mx-0">
                The Yoga7 App has it all – book the best classes for your schedule,
                see future class schedules, access on-demand classes and more!
              </p>

              <div className="mt-8 flex justify-center">
                <button
                    type="button"
                    className="
                  inline-flex
                  h-[48px]
                  min-w-[200px]
                  items-center
                  justify-center
                  rounded-full
                  bg-white
                  px-8
                  font-helvetica
                  text-[22px]
                  font-bold
                  uppercase
                  leading-[38px]
                  text-[#32392A]
                  sm:text-[30px]
                "
                >
                  GET THE APP
                </button>
              </div>
            </div>
          </div>

          {/* Bottom title */}
          <div className="mt-16 text-center font-helvetica text-[44px] font-medium leading-[48px] text-white sm:text-[56px] sm:leading-[62px] lg:text-[62px] lg:leading-[68px]">
            Get Started Today
          </div>
        </div>
      </section>
  );
}
